export default __webpack_public_path__ + "static/media/transportation1.47241ab9.jpg";